import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-phone-input-2/lib/material.css";
import * as constants from "../../utils/constants";

import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
    Box,
    Divider,
    makeStyles,
    Hidden
} from "@material-ui/core";
import { ThemeProvider } from "react-jss";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import numeral from "numeral";
import { theme } from "../../components/ui/theme";
import AddDriverForm from "../../components/AdditionalDriverCheckin/AddDriverForm";
import * as checkinActions from "src/actions/checkinActions";

import { Typography } from "@packages/ui";
import BookingDetailHeader from "../../components/Checkin/BookingDetailHeader";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import getCountryFromURL from "../../utils/getCountryFromUrl";
import _ from "lodash";
import { REGIONS } from "../../utils/constants";

import KeyboardArrowRightSharpIcon from '@material-ui/icons/KeyboardArrowRightSharp';

import { apiURI } from "../../env";

const CheckinSummary = () => {
    const checkin = useSelector((state) => state.checkin);
    const classes = useStyles();
    const brand = getBrandFromUrl();
    const dispatch = useDispatch();
    const [expand, setExpanded] = useState(false);
    const [expandAdditionalDetails, setExpandedAdditionalDetails] = useState(false);
    const [expandAddDriver, setExpandAddDriver] = useState(false); // default open
    const [addDriverQuestionaireCompleted, setAddDriverQuestionaireCompleted] = useState(!(checkin.verifyCC && checkin.verifyID));
    const [openUncompleteAddDriverAlert, setOpenUncompleteAddDriverAlert] = useState(false);
    const dataUpdate = useRef(null);

    const mobileNumber = checkin.reservation?.Renter?.Address?.HomeTelephoneNumber
                        ? checkin.reservation.Renter.Address.HomeTelephoneNumber
                        : checkin.customer?.LatestCustomer?.Address?.HomeTelephoneNumber || "";
    const lastName = useSelector((state) => state.checkin.reservation.Renter.RenterName.lastName);
    const bookingNumber = checkin.resNo;

    const reservationNumber = React.useMemo(() => {
        return checkin.resNo;
    }, [checkin.resNo]);
    const randomNumber = React.useMemo(() => {
        return Math.random();
    }, [checkin.resNo]);
    const isAdditionalDriver = useSelector((state) => state.checkin.isAdditionalDriver);
    const idVerificationSkipped = useSelector((state) => state.checkin.idVerificationSkipped);

    const [visibleSection, setVisibleSection] = useState(null);
    const handleClick = (section) => {
        setVisibleSection(section);
    };

    let termsAndConditionsUrl = "";
    let themeColor;
    const country = getCountryFromURL();

    if (country == "NZ") {
        switch (brand) {
            case "Ace":
                termsAndConditionsUrl = constants.ACE_TERMS_NZ_PDF;
                break;
            case "Dollar":
                termsAndConditionsUrl = constants.DOLLAR_TERMS_NZ;
                break;
            case "Thrifty":
                termsAndConditionsUrl = constants.THRIFTY_TERMS_NZ;
                break;
            default:
                termsAndConditionsUrl = constants.HERTZ_TERMS_NZ_PDF;
                break;
        }
    } else if (country == "AU") {
        switch (brand) {
            case "Ace":
                termsAndConditionsUrl = constants.ACE_TERMS_AU_PDF;
                break;
            case "Dollar":
                termsAndConditionsUrl = constants.DOLLAR_TERMS_AU;
                break;
            case "Thrifty":
                termsAndConditionsUrl = constants.THRIFTY_TERMS_AU;
                break;
            default:
                termsAndConditionsUrl = constants.HERTZ_TERMS_AU_PDF;
                break;
        }
    }

    switch (brand) {
        case "Ace":
            themeColor = constants.ACE_THEME_COLOR
            break;
        case "Dollar":
            themeColor = constants.DOLLAR_THEME_COLOR
            break;
        case "Thrifty":
            themeColor = constants.THRIFTY_THEME_COLOR
            break;
        default:
            themeColor = constants.HERTZ_THEME_COLOR
            break;
    }

    const [form, setForm] = useState({
        ..._.cloneDeep(checkin.reservation).Renter,
        ReservationMainNote: checkin.reservation.ReservationMainNote,
        TermsAndConditions: false,
    });

    const Countries = _.sortBy(REGIONS, ["label"]);

    const options = Countries.map((option) => {
        const countryFirstLetter = option.country[0].toLocaleUpperCase();
        return {
            countryFirstLetter: countryFirstLetter,
            ...option,
        };
    });


    useEffect(() => {
        if (idVerificationSkipped && !checkin.finalPageSMSSent) {
            dispatch(
                checkinActions.sendSMSInvite({
                    mobileNumber,
                    lastName,
                    bookingNumber,
                    brand,
                    country,
                    token: checkin.auth.token,
                    idVerificationSkipped: true,
                    finalPageSMSSent: true
                })
            );
        }

        dataUpdate.current = true;
        if (dataUpdate.current) {
            dispatch(
                checkinActions.getDetails({
                    reservation: checkin.reservation,
                    token: checkin.auth.token,
                })
            );
            dispatch(
                checkinActions.frontdeskGetEstimate({
                    resno: checkin.resNo,
                    token: checkin.auth.token,
                })
            );
            dispatch(
                checkinActions.resOptions({
                    resno: checkin.resNo,
                    token: checkin.auth.token,
                })
            );
        }
        return () => (dataUpdate.current = false);
    }, []);

    useEffect(() => {
        if (!_.isEmpty(checkin.reservation)) {
            estimateReservation();
        }
    }, [checkin.reservation]);

    const estimateReservation = () => {
        const { ReservationMainNote, ...Renter } = form;
        const RateID = _.find(checkin.details?.WebRates?.Rates, {
            Class: checkin.reservation.Vehicle.classCode,
        })?.RateID;

        if (!_.isEmpty(checkin.details?.WebRates?.Rates)) {
            // dispatch(
            //   checkinActions.resEstimate({
            //     token: checkin.auth.token,
            //     ReservationMainNote,
            //     Renter,
            //     RateID,
            //     Reservation: checkin.reservation,
            //   })
            // );
        }
    };

    let dayRate = _.find(checkin?.estimate?.Estimate?.Customer?.TimeCharges, function (ratesObject) {
        if (_.includes(ratesObject.Description, "DAYS")) {
            return ratesObject;
        }
    });
    const estimatecharges = [];


    if (dayRate != undefined) {
        estimatecharges.push(dayRate);
    } else {
        dayRate = { Quantity: "0", SubTotal: "0" };
    }

    if (checkin.PrePaid == true) {
        dayRate = { Quantity: "", SubTotal: "Prepaid" };
    }

    //Discount Rate
    const discountRate = _.find(checkin?.estimate?.Estimate?.Customer?.TimeCharges, function (
        discountObject
    ) {
        if (_.includes(discountObject.Description, "Discount") && discountObject.SubTotal != 0) {
            return discountObject;
        }
    });

    if (_.has(discountRate, "Discount")) {
        estimatecharges.push(discountRate);
    }


    const RenterCharges = [];
    _.reduce(
        _.get(checkin, "estimate.Estimate.Customer.OptionsCharges", []),
        function (accumulator, batch) {
            if (_.has(batch, "Quantity")) {
                const { Quantity, SubTotal, Description } = batch;
                if (parseInt(Quantity) != 0 && parseInt(SubTotal) != 0) {
                    RenterCharges.push(batch);
                    estimatecharges.push(batch);
                }
            }
        },
        0
    );
    const myRef = useRef(null);

    const icon_Url_Complete1 =
        brand == 'Ace' ?
            constants.ACE_COMPLETE_ICON_1 :
            brand == 'Dollar' ?
                constants.DOLLAR_COMPLETE_ICON_1 :
                brand == 'Thrifty' ?
                    constants.THRIFTY_COMPLETE_ICON_1 : constants.HERTZ_COMPLETE_ICON_1;


    return (
        <div>
            <ThemeProvider theme={theme} className={classes.removeContainer}>

                <Grid container direction="column" justify="center" alignItems="center" style={{ marginTop: 40, padding: 15 }}>
                    <Grid item>
                        <Typography variant={"h2"} className={classes.bold}>You’re Checked-in!</Typography>
                    </Grid>
                    <Grid item style={{ margin: "10px 0" }}>
                        <img className={classes.icon} src={icon_Url_Complete1} />
                    </Grid>

                    {/* {!idVerificationSkipped && ( */}
                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                        style={{ marginTop: 10 }}
                    >
                        <Grid item xs={12} lg={8} md={10} style={{ marginTop: 0, marginBottom: 20 }}>
                            <Accordion
                                className={classes.accordion}
                                expanded={expandAdditionalDetails}
                                onChange={() => setExpandedAdditionalDetails(!expandAdditionalDetails)}
                                ref={myRef}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon style={{ fontSize: 36 }} />}
                                    aria-controls={`panel1a-content`}
                                    id={`panel1a-header`}
                                    className={classes.summary}
                                >
                                    <Typography className={classes.headerFont} variant={"h3"}>
                                        Additional Details
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                    <Grid
                                        container
                                        direction="row"
                                    >
                                        <Grid container onClick={() => handleClick('section1')} style={{ opacity: visibleSection === 'section1' ? 1 : 0.5, transition: 'opacity 0.6s ease-in-out' }}>
                                            <Grid item style={{ marginTop: 7.5, marginBottom: 0, padding: '0 5%' }}>
                                                <Typography style={{ fontSize: 16 }} variant="h4">
                                                    You have completed online check in and may be eligible for express service; you may receive a text message on the day of your reservation with details on how to collect your keys.
                                                </Typography>
                                            </Grid>
                                            <Grid item style={{ marginTop: 15, marginBottom: 10, padding: '0 5%' }}>
                                                <Typography style={{ fontSize: 16 }} variant="h4">
                                                    If you do not receive a text message, please proceed to the counter at the location to collect your keys.
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid style={{ width: '100%', marginTop: 15, marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                                            <Divider style={{ width: '100%', backgroundColor: themeColor, height: 2 }} />
                                        </Grid>

                                        <Grid container onClick={() => handleClick('section2')} style={{ opacity: visibleSection === 'section2' ? 1 : 0.5, transition: 'opacity 0.6s ease-in-out' }}>
                                            <Grid item style={{ padding: '0 5%', marginTop: 15, marginBottom: 0 }}>
                                                <Typography style={{ fontSize: 16 }} variant="h4">
                                                    On the day of your rental, please remember to bring:
                                                </Typography>
                                            </Grid>
                                            <Grid style={{ display: 'flex', justifyContent: 'center', textAlign: 'left', marginTop: 15, marginBottom: 0 }}>
                                                <KeyboardArrowRightSharpIcon style={{ color: themeColor, fontSize: '35px' }} />
                                                <Typography variant="h4" style={{ lineHeight: '2', fontSize: 16 }}>
                                                    Your current driver’s licence
                                                </Typography>
                                            </Grid>
                                            <Grid style={{ display: 'flex', justifyContent: 'center', textAlign: 'left' }}>
                                                <KeyboardArrowRightSharpIcon style={{ color: themeColor, fontSize: '35px' }} />
                                                <Typography variant="h4" style={{ lineHeight: '2', fontSize: 16 }}>
                                                    A credit or debit card in your name
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid style={{ width: '100%', marginTop: 15, marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                                            <Divider style={{ width: '100%', backgroundColor: themeColor, height: 2 }} />
                                        </Grid>

                                        <Grid container onClick={() => handleClick('section3')} style={{ opacity: visibleSection === 'section3' ? 1 : 0.5, transition: 'opacity 0.6s ease-in-out' }}>
                                            <Grid item style={{ padding: '0 5%', marginTop: 15, marginBottom: 5 }} id="t&c">
                                                <Typography style={{ fontSize: 16 }} variant="h4">
                                                    For more details regarding bonds and renters requirements, please see our <a href={termsAndConditionsUrl} download>terms and conditions.</a>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                    {/* )} */}
                    {/* <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                        style={{ marginTop: 10 }}
                    >
                        <Grid item xs={12} lg={8} md={10} style={{ marginTop: 0, marginBottom: 20 }}>
                            <Accordion
                                className={classes.accordion}
                                expanded={expandAdditionalDetails}
                                onChange={() => setExpandedAdditionalDetails(!expandAdditionalDetails)}
                                ref={myRef}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon style={{ fontSize: 36 }} />}
                                    aria-controls={`panel1a-content`}
                                    id={`panel1a-header`}
                                    className={classes.summary}
                                >
                                    <Typography className={classes.headerFont} variant={"h3"}>
                                        Additional Details
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                    <Grid
                                        container
                                        direction="row"
                                    >
                                        <Grid container onClick={() => handleClick('section1')} style={{ opacity: visibleSection === 'section1' ? 1 : 0.5, transition: 'opacity 0.6s ease-in-out' }}>
                                            <Grid item style={{ marginTop: 7.5, marginBottom: 0, padding: '0 5%' }}>
                                                <Typography style={{ fontSize: 16 }} variant="h4">
                                                    If you are eligible for counter bypass, an SMS will be sent prior to your collection time with details on accessing your vehicle.
                                                </Typography>
                                            </Grid>
                                            <Grid item style={{ marginTop: 15, marginBottom: 0, padding: '0 5%' }}>
                                                <Typography style={{ fontSize: 16 }} variant="h4">
                                                    If you do not receive this SMS, or are not eligible for counter bypass, please head in store to our Express or Loyalty counters to collect your vehicle.
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid style={{ width: '100%', marginTop: 15, marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                                            <Divider style={{ width: '100%', backgroundColor: themeColor, height: 2 }} />
                                        </Grid>

                                        <Grid container onClick={() => handleClick('section2')} style={{ opacity: visibleSection === 'section2' ? 1 : 0.5, transition: 'opacity 0.6s ease-in-out' }}>
                                            <Grid item style={{ padding: '0 5%', marginTop: 15, marginBottom: 0 }}>
                                                <Typography style={{ fontSize: 16 }} variant="h4">
                                                    On the day of your rental, please remember to bring:
                                                </Typography>
                                            </Grid>
                                            <Grid style={{ display: 'flex', justifyContent: 'center', textAlign: 'left', marginTop: 15, marginBottom: 0 }}>
                                                <KeyboardArrowRightSharpIcon style={{ color: themeColor, fontSize: '35px' }} />
                                                <Typography variant="h4" style={{ lineHeight: '2', fontSize: 16 }}>
                                                    Your current driver’s licence
                                                </Typography>
                                            </Grid>
                                            <Grid style={{ display: 'flex', justifyContent: 'center', textAlign: 'left' }}>
                                                <KeyboardArrowRightSharpIcon style={{ color: themeColor, fontSize: '35px' }} />
                                                <Typography variant="h4" style={{ lineHeight: '2', fontSize: 16 }}>
                                                    A credit or debit card in your name
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid style={{ width: '100%', marginTop: 15, marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                                            <Divider style={{ width: '100%', backgroundColor: themeColor, height: 2 }} />
                                        </Grid>

                                        <Grid container onClick={() => handleClick('section3')} style={{ opacity: visibleSection === 'section3' ? 1 : 0.5, transition: 'opacity 0.6s ease-in-out' }}>
                                            <Grid item style={{ padding: '0 5%', marginTop: 15, marginBottom: 5 }} id="t&c">
                                                <Typography style={{ fontSize: 16 }} variant="h4">
                                                    For more details regarding bonds and renters requirements, please see our <a href={termsAndConditionsUrl} download>terms and conditions.</a>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid> */}

                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                        style={{ marginTop: 10 }}
                    >
                        <Grid item xs={12} lg={8} md={10} style={{ marginTop: 0, marginBottom: 20 }}>
                            <Accordion
                                className={classes.accordion}
                                expanded={expand}
                                onChange={() => setExpanded(!expand)}
                                ref={myRef}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon style={{ fontSize: 36 }} />}
                                    aria-controls={`panel1a-content`}
                                    id={`panel1a-header`}
                                    className={classes.summary}
                                >
                                    <Typography className={classes.headerFont} variant={"h3"}>
                                        Booking Summary
                                    </Typography>
                                </AccordionSummary>
                                <BookingDetailHeader />
                                {/* <AccordionDetails>
                                    <Grid
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                        style={{ textAlign: "center" }}
                                    >
                                        <Grid item xs={12}>
                                            <Typography variant={"h2"} style={{ margin: 10 }}>
                                                {checkin?.details?.Vehicle
                                                    ? _.get(checkin, "details.Vehicle[0].title", " ") + " or Similar"
                                                    : ""}
                                            </Typography>
                                        </Grid>
                                        {brand == "Hertz" && (
                                            <Grid item xs={12}>
                                                <img
                                                    src={`https://images.hertz.com/vehicles/220x128/${checkin?.details?.Vehicle
                                                        ? _.get(checkin, "details.Vehicle[0].image", "")
                                                        : ""
                                                        }`}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </AccordionDetails> */}
                            </Accordion>
                        </Grid>
                    </Grid>

                    {/* //Only show additional driver form, if main driver required for id/cc verify */}
                    {(checkin.verifyCC && checkin.verifyID && !checkin.additionalDriverIdVerified) && 
                        // <Accordion
                        //     className={classes.accordion}
                        //     expanded={true}
                        //     onChange={() => setExpanded(!expanded)}
                        //     ref={myRef}
                        // >
                        //     <AccordionDetails>
                        //         <Grid item xs={12} md={6}>
                        //             <AddDriverForm setCompletedQuestionaire={setAddDriverQuestionaireCompleted} completed={addDriverQuestionaireCompleted} openUncompleteAddDriverAlert={openUncompleteAddDriverAlert} setOpenUncompleteAddDriverAlert={setOpenUncompleteAddDriverAlert} defaultOpen={true} />
                        //         </Grid>
                        //     </AccordionDetails>
                        // </Accordion>
                        <Accordion
                            className={classes.accordion}
                            expanded={expandAddDriver}
                            onChange={() => setExpandAddDriver(!expandAddDriver)}
                            ref={myRef}
                            style={{ marginTop: 10 }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon style={{ fontSize: 36 }} />}
                                aria-controls="add-driver-content"
                                id="add-driver-header"
                                className={classes.summary}
                            >
                                <Typography className={classes.headerFont} variant="h3">
                                    Additional Driver
                                </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <AddDriverForm
                                            setCompletedQuestionaire={setAddDriverQuestionaireCompleted}
                                            completed={addDriverQuestionaireCompleted}
                                            openUncompleteAddDriverAlert={openUncompleteAddDriverAlert}
                                            setOpenUncompleteAddDriverAlert={setOpenUncompleteAddDriverAlert}
                                            defaultOpen={true}
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    }
                </Grid>
            </ThemeProvider>

            {/* {reservationNumber != "" && (
                <img
                    src={`${apiURI}/pixel/${window.location.pathname.replace(/\//g, '_')}.png?b=${reservationNumber}&a=${"completed"}&country=${getCountryFromURL()}&c=${randomNumber}&brand=${brand}&t=${isAdditionalDriver ? "additional_driver" : "primary_driver"}`}
                    style={{ display: "none" }}
                />
            )} */}
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    accordion: {
        marginLeft: 10,
        marginRight: 10,
        border: `1px solid ${theme.palette.primary.main}`,
        boxShadow: "none",
        "&.Mui-expanded": {
            margin: 10,
        },
    },
    headerFont: {
        color: "black",
    },
    summary: {
        backgroundColor: "#ffffff00",
        borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
    removeContainer: {
        ".pac-container:after": {
            content: "none !important",
        },
    },
    icon: {
        width: "150px"
    },
}));

export default CheckinSummary;
